module.exports = __webpack_public_path__ + "static/media/no-video.c9522d18.png";